<div class="topbar-container row" [ngClass]="{ topbarScrolled: scrolled }">
  <div class="right-side row desktop">
    <span class="logo"></span>
    <div [ngClass]="{ navbarScrolled: scrolled }" class="navbar row">
      <a (click)="scrollTo('solutions')">{{'TOP_BAR_MENU.SOLUTIONS' | translate}}</a>
      <a (click)="scrollTo('howItWork')">{{'TOP_BAR_MENU.HOW_IT_WORKS' | translate}}</a>
      <a (click)="scrollTo('customers-tell')">{{'TOP_BAR_MENU.CUSTOMERS' | translate}}</a>
      <a (click)="scrollTo('prices')">{{'TOP_BAR_MENU.PRICES' | translate}}</a>
      <a (click)="scrollTo('commonQuestions')">{{'TOP_BAR_MENU.COMMON_QUESTIONS' | translate}}</a>
    </div>
  </div>
  <div class="left-side  row">
    <a  href="https://diners.spintuwin.com/" target="_blank" class="external-link">
      {{'TOP_BAR_MENU.LINK'|translate}}
      </a>
    <button type="button" class="command-button createRouletteButton desktop"
      (click)="createRoulette()">{{'ROULETTE.CREATE_ROULETTE' | translate}}</button>
   
    <p-dropdown *ngIf="isDomainHe" class="langButton" [options]="languages" [appendTo]="null" [(ngModel)]="selectedLanguage"
      (onChange)="changeLanguage()">
      <ng-template let-item pTemplate="selectedItem">
        <img class="languageIcon" [src]="item.icon" />
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="iconDiv">
          <img class="languageIcon" *ngIf="item.code!=selectedLanguage.code" [src]="item.icon" />
        </div>
      </ng-template>
    </p-dropdown>
 
    <button type="button" class="p-button-rounded p-button-info p-button-outlined loginButton" (click)="login()">
    </button>
       
  </div>
</div>
